import apiClient from 'utilities/apiClient';

export const getReports = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.audit}/${url}`, payload, true);
};

export const getFailedLogs = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.print}/${url}`, payload, true);
};

export const downloadReport = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.audit}/${url}`, payload, true);
};

export const getpos = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.invtracker}/${url}`, payload, true);
};

export const getStage1BatchesApi = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.audit}/${url}`, payload, true);
};

export const getMaterialBatches = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.materialList}/all-batches`,
    payload,
    true
  );
};

export const getOtherReportPdf = (payload) => {
  return apiClient.get(`${apiClient.Urls.otherReports}`, payload, true);
};

export const getOtherReportCsv = (payload) => {
  return apiClient.getBlob(`${apiClient.Urls.otherReports}`, payload, true);
};

export const getBinSeriesList = () => {
  return apiClient.get(`${apiClient.Urls.otherReports}/bin-series`, {}, true);
};

export const getMaterialReceiptAuditTrail = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.auditTrailConsolidated}/material-receipt`,
    payload,
    true
  );
};

export const getMaterialReceiptAuditTrailPdf = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.auditTrailConsolidated}/material-receipt/pdf`,
    payload,
    true
  );
};

export const getMaterialReceiptAuditCandidates = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.auditTrailConsolidated}/material-receipt/candidates`,
    payload,
    true
  );
};

export const getMaterialReceiptRangeCandidates = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.auditTrailConsolidated}/material-receipt/range-candidates`,
    payload,
    true
  );
};

export const getMaterialReceiptCombinedPdf = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.auditTrailConsolidated}/material-receipt/combined-pdf`,
    payload,
    true
  );
};

// WIP Label Audit Trail (2026-05-18)
export const getWipLabelCandidates = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.auditTrailConsolidated}/wip-label/candidates`,
    payload,
    true
  );
};

export const getWipLabelTimeline = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.auditTrailConsolidated}/wip-label/timeline`,
    payload,
    true
  );
};

export const getWipLabelPdf = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.auditTrailConsolidated}/wip-label/pdf`,
    payload,
    true
  );
};

export const getMscLabelCandidates = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.auditTrailConsolidated}/miscellaneous-label/candidates`,
    payload,
    true
  );
};

export const getMscLabelTimeline = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.auditTrailConsolidated}/miscellaneous-label/timeline`,
    payload,
    true
  );
};

export const getMscLabelPdf = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.auditTrailConsolidated}/miscellaneous-label/pdf`,
    payload,
    true
  );
};

// Move Material Audit Trail (2026-05-19)
export const getMoveMaterialAuditCandidates = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.auditTrailConsolidated}/move-material/candidates`,
    payload,
    true
  );
};

export const getMoveMaterialAuditTrail = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.auditTrailConsolidated}/move-material`,
    payload,
    true
  );
};

export const getMoveMaterialAuditTrailPdf = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.auditTrailConsolidated}/move-material/pdf`,
    payload,
    true
  );
};

// Line Clearance — Material Verification Audit Trail (2026-06-12)
export const getLcMatVerCandidates = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.auditTrailConsolidated}/lc-material-verification/candidates`,
    payload,
    true
  );
};

export const getLcMatVerTimeline = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.auditTrailConsolidated}/lc-material-verification`,
    payload,
    true
  );
};

export const getLcMatVerPdf = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.auditTrailConsolidated}/lc-material-verification/pdf`,
    payload,
    true
  );
};

// Line Clearance — Product Verification Audit Trail (2026-06-12)
export const getProdVerCandidates = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.auditTrailConsolidated}/product-verification/candidates`,
    payload,
    true
  );
};

export const getProdVerTimeline = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.auditTrailConsolidated}/product-verification`,
    payload,
    true
  );
};

export const getProdVerPdf = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.auditTrailConsolidated}/product-verification/pdf`,
    payload,
    true
  );
};

// MRR Audit Trail (2026-05-20)
export const getMrrAuditCandidates = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.auditTrailConsolidated}/mrr/candidates`,
    payload,
    true
  );
};

export const getMrrAuditTrail = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.auditTrailConsolidated}/mrr`,
    payload,
    true
  );
};

export const getMrrAuditTrailPdf = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.auditTrailConsolidated}/mrr/pdf`,
    payload,
    true
  );
};
